// src/utils/getUserRole.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Повертає роль користувача з /users/{uid}.
 * НІЯКИХ запитів до всієї колекції — лише пряме читання свого документа.
 * Якщо документа ще немає – повертаємо 'user' (а створення зробить ensureUserDoc).
 */
export async function getUserRole(uid) {
  if (!uid) return 'user';

  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    // ще не створили user-док – вважаймо 'user'
    return 'user';
  }

  const data = snap.data();
  return data?.role || 'user';
}
